import { PrebidConfig } from '../types';

declare global {
  interface Window {
    pbjs: any;
    googletag: any;
  }
}

export const initPrebid = (config: PrebidConfig): void => {
  const { pbjs } = window;
  
  pbjs.que.push(() => {
    pbjs.setConfig({
      debug: process.env.NODE_ENV === 'development',
      bidderTimeout: config.timeout,
      enableSendAllBids: true,
    });
  });
}; 